const header = [
	{
		'name': "Commodity",
		'id': 0,
		'isActive': false
	},
	{
		'name': "Details",
		'id': 1,
		'isActive': false
	},
	{
		'name': "Recording",
		'id': 2,
		'isActive': false
	}
];


export {
	header,
}
